"use strict";

import angular from "angular";

import template from "./sidebar-navigation.component.html";
import "./themes/sidebar-navigation-dark.component.scss";
import "./themes/sidebar-navigation.component.scss";

import _ from "lodash";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { Events } from "../../../presentation/services/Events/Events";
import { RolesUtils } from "../../../utils/roles/roles";
import helpDialogTemplate from "../../dialogs/help-dialog/help-dialog.html";

const version = require("../../../../public/js/version");

export class SidebarNavigationComponent {
    constructor(
        $transitions,
        $location,
        $state,
        $stateParams,
        $scope,
        NavigationService,
        AccountingFactory,
        DSNDialogService,
        ChatHubsbotService,
        JWTService
    ) {
        this.$transitions = $transitions;
        this.$location = $location;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.NavigationService = NavigationService;
        this.AccountingFactory = AccountingFactory;
        this.DSNDialogService = DSNDialogService;
        this.ChatHubsbotService = ChatHubsbotService;
        this.JWTService = JWTService;
        this.version = version;
        this.Events = new Events();
    }

    $onInit() {
        this.NavigationService.setValidations();

        this.NavigationService.setAvailables(this.$state.current.name);

        this.NavigationService.setParams("source", "contabil");

        this.NavigationService.setParams("id", this.$state.params.id);

        this.NavigationService.setHref();

        this.$transitions.onStart({}, (transition) => {
            this.NavigationService.setAvailables(transition.to().name);
        });
        this.toggleClass();
        this.$scope.$on("$destroy", () => {
            this.toggleClass();
        });

        this.user = new UserDataAdapter().user();

        this.isBusinessman = _.get(this.user, "roles").includes("Empresa");

        this.setShowFeedback();
    }

    setShowFeedback() {
        this.showFeedback = RolesUtils.userIsInRole({
            roles: [
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabilidade",
                "Contabil",
                "Comercial",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ]
        });
    }

    toggleClass() {
        angular
            .element(document.getElementsByTagName("body"))
            .toggleClass("sidebar-navigation-active");
    }

    toggleOpenMenu() {
        angular
            .element(document.getElementById("SidebarNavigation"))
            .toggleClass("sidebar-navigation__opened");
    }

    /**
     * @public
     * Faz logout
     */
    logout = () => {
        this.JWTService.signout();
    };

    /**
     * @public
     * Abre dialog de feedback e erros
     */

    onOpenHelpDialog = () => {
        const body = angular.element(document.querySelector("body"));
        body.addClass("overwrite-chat-rules");
        this.DSNDialogService.custom({
            controller: "HelpDialogCtrl as $ctrl",
            locals: {
                templateHtml: helpDialogTemplate,
                width: "512px",
                title: "Dar feedback"
            },
            after: {
                hide: () => {
                    body.removeClass("overwrite-chat-rules");
                },
                cancel: () => {
                    this.ChatHubsbotService.toMaintain();
                }
            }
        });
        this.Events.send("Menu.Feedback");
    };

    /**
     * @public
     * @description - Faz o redirecionamento para empresas
     */
    onGetCompanyRedirect = () => {
        if (
            this.$state.current.name.indexOf("nucont.accounting.overview") ===
            -1
        ) {
            const accountingId = this.AccountingFactory.getId();

            return this.$state.href(
                "nucont.accounting.overview.portfolio.companies.resume",
                {
                    accountingId
                }
            );
        }
    };

    cancelRedirect(item) {
        if (!item.cancelredirect) return false;
        return item.cancelredirect.includes(this.$state.current.name);
    }

    hasVisibleSubmenu(item) {
        if (!item.submenu || item.submenu.length === 0) return false;
        return item.submenu.some(
            (sub) => !sub.hidden && sub.contracted && sub.show
        );
    }
}

SidebarNavigationComponent.$inject = [
    "$transitions",
    "$location",
    "$state",
    "$stateParams",
    "$scope",
    "NavigationService",
    "AccountingFactory",
    "DSNDialogService",
    "ChatHubsbotService",
    "JWTService"
];

const name = "sidebarNavigationComponent";
const def = {
    controller: SidebarNavigationComponent,
    bindings: {},
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
